<template>
  <div>
    <template v-if="signinOptions.google || signinOptions.github || signinOptions.heroku">
      <div class="oauth-options text-regular">
        <a
          v-if="signinOptions.google"
          :href="`/auth/google${returnUrlQuery}`"
          class="oauth-link link-google btn-block"
          data-testid="google-signin"
        >
          <elIcon
            size="xl"
            name="google"
          />
          <div class="v-divider" />
          {{ $t('signin.form.with', { service: 'Google'}) }}
        </a>
        <a
          v-if="signinOptions.github"
          :href="`/auth/github${returnUrlQuery}`"
          class="oauth-link link-github btn-block"
          data-testid="github-signin"
        >
          <elIcon
            size="xl"
            name="github"
          />
          <div class="v-divider" />
          {{ $t('signin.form.with', { service: 'GitHub'}) }}
        </a>
        <a
          v-if="signinOptions.heroku"
          :href="`/auth/heroku${returnUrlQuery}`"
          class="oauth-link link-heroku btn-block"
          data-testid="heroku-signin"
        >
          <elIcon
            size="xl"
            name="heroku"
          />
          <div class="v-divider" />
          {{ $t('signin.form.with', { service: 'Heroku'}) }}
        </a>
        <div
          v-if="signinOptions.local"
          class="signin-option-decorator text-regular"
        >
          <span>{{ $t('common.or') }}</span>
        </div>
      </div>
    </template>

    <template v-if="signinOptions.local">
      <form
        id="signin-form"
        class="signin-form form-primary"
        :action="`/auth/localsignin/${type}`"
        method="post"
        data-testid="local-signin"
      >
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <label
                for="login-email"
                class="signin-form__label input-group-text"
              >
                <elIcon
                  size="lg"
                  name="envelope"
                />
              </label>
            </div>
            <input
              id="login-email"
              data-testid="email"
              type="email"
              :aria-label="$t('signin.form.email')"
              class="form-control"
              name="email"
              required
              :placeholder="$t('signin.form.email')"
              autocomplete="email"
            >
          </div>
        </div>
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend">
              <label
                for="login-pass"
                class="signin-form__label input-group-text"
              >
                <elIcon
                  size="lg"
                  name="asterisk"
                />
              </label>
            </div>
            <input
              id="login-pass"
              data-testid="password"
              type="password"
              :aria-label="$t('signin.form.password')"
              class="form-control"
              name="password"
              required
              :placeholder="$t('signin.form.password')"
              autocomplete="current-password"
            >
          </div>
        </div>

        <div class="form-group clearfix">
          <button
            data-testid="sign-in"
            type="submit"
            class="btn btn-primary btn-block"
          >
            <elIcon name="lock" />
            <span class="align-middle ml-1">{{ $t('signin.form.signIn') }}</span>
          </button>
        </div>

        <input
          type="hidden"
          name="returnurl"
          :value="returnUrl"
        >
        <input
          type="hidden"
          name="_csrf"
          :value="__csrfToken"
        >
      </form>

      <div class="form-group row mb-0">
        <div
          v-if="emailAccount"
          class="col-sm-6 alternate-links"
          data-testid="email-account"
        >
          <a
            class="text-regular"
            href="/account/forgot-password"
          >
            {{ $t('signin.form.forgotPassword') }}
          </a>
        </div>
        <div
          v-if="loginSignup"
          class="col-sm-6 alternate-links text-right"
          data-testid="login-signup"
        >
          <a
            class="text-regular"
            href="/account/signup"
          >
            {{ $t('signin.form.signUp') }}
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { elIcon } from '@ui/components'
import { useRootStore } from 'client/stores/root'

export default {
  components: {
    elIcon
  },
  props: {
    type: {
      type: String,
      required: true
    },
    signinOptions: {
      type: Object,
      default: () => ({})
    },
    emailAccount: Boolean,
    loginSignup: Boolean
  },
  computed: {
    ...mapState(useRootStore, {
      __csrfToken: '__csrfToken'
    }),
    returnUrl() {
      return new URLSearchParams(window.location.search).get('returnurl')
    },
    returnUrlQuery() {
      if (!this.returnUrl) return ''

      return `?returnurl=${encodeURIComponent(this.returnUrl)}`
    }
  }
}
</script>
